import router from '@/router'
import WechatAuth from '@/libs/wechat-auth'
import QQAuth from '@/libs/qq-auth'
import { checkSSO, loginWechat, loginQQ } from '@/api/user'
import { setToken, getToken, removeToken, setWXInfo, setUserInfo, getUserInfo } from '@/libs/cookie-storage'
import { AppType, ConstConfig, getSearchParams } from '@/utils'
import { sendPassport } from '@/libs/ds-bridge'
import url from 'url'
import querystring from 'querystring'

const wechatAuth = new WechatAuth({
  appid: ConstConfig.wxAppId // 微信appid
})

const qqAuth = new QQAuth({
  client_id: ConstConfig.client_id // 微信appid
})

function checkPassportValid() {
  return new Promise((resolve, reject) => {
    checkSSO().then(response => {
      const data = response.data
      if (data && !data.session) {
        removeToken()
        resolve(false)
      } else {
        if (data.passport) {
          setToken(data.passport)
        }
        if (data.user) {
          setUserInfo(data.user)
        }
        resolve(true)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

function getPassportByWeChat(authCode) {
  return new Promise((resolve, reject) => {
    loginWechat(authCode).then(response => {
      if (response) {
        const data = response && response.data
        if (data.openId && data.accessToken) {
          setWXInfo({
            openId: data.openId,
            accessToken: data.accessToken
          })
        }
        if (data && data.passport) {
          setToken(data.passport)
        } else {
          resolve(false)
        }
        if (data && data.user) {
          setUserInfo(data.user)
        }
        resolve(data)
      } else {
        resolve(false)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

function getPassportByQQ(authCode) {
  return new Promise((resolve, reject) => {
    loginQQ(authCode).then(response => {
      const data = response.data
      if (data.passport) {
        setToken(data.passport)
      }
      if (data.openId && data.accessToken) {
        setWXInfo({
          openId: data.openId,
          accessToken: data.accessToken
        })
      }
      if (data.user) {
        setUserInfo(data.user)
      }
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
}

function authHandleInWeChat(isNoRedirect) {
  const query = querystring.parse(url.parse(window.location.href).query)
  let code = query.code
  if (Array.isArray(code)) {
    code = code[code.length - 1]
  }
  const authCode = wechatAuth.getAuthCode()
  if (code && !authCode) {
    wechatAuth.setAuthCode(code)
    return new Promise((resolve, reject) => {
      getPassportByWeChat(code).then(response => {
        if (response && response.passport) {
          wechatAuth.removeUrlCodeQuery()
          // window.eventBus.$emit('WechatAuth', response.passport)
          resolve(true)
        } else {
          wechatAuth.removeAuthCode() // 微信与bmb未绑定
          if (!isNoRedirect) {
            const redirect = window.sessionStorage.getItem('redirect_path')
            if (redirect.indexOf('redirect=') === -1) {
              router.replace({ name: 'Login', query: { redirect: encodeURIComponent(redirect) } })
            }
          }
          resolve(false)
        }
      }).catch(error => {
        reject(error)
      })
    })
  } else {
    let redirect = window.location.hash
    redirect = redirect.substring(1)
    window.sessionStorage.setItem('redirect_path', redirect)
    wechatAuth.openAuthPage()
  }
}

function authHandleInQQ(isNoRedirect) {
  const query = querystring.parse(url.parse(window.location.href).query)
  const code = query.code
  if (Array.isArray(code)) {
    return
  }
  const authCode = qqAuth.getAuthCode()
  if (code && !authCode) {
    qqAuth.setAuthCode(code)
    return new Promise((resolve, reject) => {
      getPassportByQQ(code).then(response => {
        if (response.passport) {
          qqAuth.removeUrlCodeQuery()
          // window.eventBus.$emit('qqAuth', response.passport)
          resolve(true)
        } else {
          qqAuth.removeAuthCode() // 微信与bmb未绑定
          if (!isNoRedirect) {
            const redirect = window.sessionStorage.getItem('redirect_path')
            if (redirect.indexOf('redirect=') === -1) {
              router.replace({ name: 'Login', query: { redirect: encodeURIComponent(redirect) } })
            }
          }
          resolve(false)
        }
      }).catch(error => {
        reject(error)
      })
    })
  } else {
    let redirect = window.location.hash
    redirect = redirect.substring(1)
    window.sessionStorage.setItem('redirect_path', redirect)
    qqAuth.openAuthPage()
  }
}

export function getUserInfoFromNative() {
  return new Promise((resolve, reject) => {
    const query = getSearchParams()
    if (AppType.isInApp() && query && query.passport) { // TODO only in app
      setToken(query.passport)
      checkSSO().then(response => {
        const data = response.data
        if (data && !!data.session) {
          if (data.passport) {
            setToken(data.passport)
          }
          if (data.user) {
            setUserInfo(data.user)
          }
        }
        resolve(true)
      }).catch(error => {
        reject(error)
      })
    } else {
      resolve(true)
    }
  })
}

export function getPassport(pageName) {
  pageName = pageName || 'Login'
  return new Promise((resolve, reject) => {
    checkPassportValid().then(response => {
      if (response) {
        wechatAuth.removeAuthCode() // 通过微信获取passport成功
        qqAuth.removeAuthCode() // 通过微信获取passport成功
        const user = getUserInfo()
        const passport = getToken()
        if (pageName === 'Verify' && user && user.hasCertificate === 1) { // 保险服务的条件多一个实名认证校验
          if (window.location.href.indexOf('passport=') < 0) { // 只有当native不带passport参赛时，才会同步H5到Native端
            sendPassport(passport)
          }
          resolve(true)
        } else if (pageName === 'Login') { // 正常Login页面逻辑的返回校验
          resolve(true)
        } else {
          router.replace({name: pageName})
          resolve(false)
        }
      } else {
        let redirect = window.location.hash
        redirect = redirect.substring(1)
        if (AppType.isInApp()) {
          router.replace({name: pageName, query: {redirect: encodeURIComponent(redirect)}})
        } else if (AppType.isInWeChat()) {
          authHandleInWeChat().then(res => {
            if (res) {
              resolve(true)
            }
          })
        } else if (AppType.isInQQ()) {
          authHandleInQQ().then(res => {
            if (res) {
              resolve(true)
            }
          })
        } else {
          if (redirect.indexOf('redirect=') === -1) {
            router.replace({ name: 'Login', query: { redirect: encodeURIComponent(redirect) } })
          }
        }
        resolve(false)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function getPassportValid() {
  return new Promise((resolve, reject) => {
    checkPassportValid().then(response => {
      if (response) {
        wechatAuth.removeAuthCode() // 通过微信获取passport成功
        qqAuth.removeAuthCode() // 通过微信获取passport成功
        resolve(true)
      } else {
        if (AppType.isInApp()) {
          resolve(false)
          // router.replace({name: pageName})
        } else if (AppType.isInWeChat()) {
          authHandleInWeChat(1).then(res => {
            if (res) {
              resolve(true)
            }
          })
        } else if (AppType.isInQQ()) {
          authHandleInQQ(1).then(res => {
            if (res) {
              resolve(true)
            }
          })
        } else {
          // router.replace({ name: pageName, query: { redirect: encodeURIComponent(redirect) } })
          resolve(false)
        }
      }
    }).catch(error => {
      reject(error)
    })
  })
}
const query = getSearchParams()
if (query && query.passport) { // TODO only in app
  setToken(query.passport)
}



// WEBPACK FOOTER //
// ./src/libs/passport.js